import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const VectorSpace = () => (
  <QPhototModuleSubtopic
    title="Vector Space"
    videos={[
      "https://www.youtube.com/embed/qqLwi27BJSA",
      "https://www.youtube.com/embed/NT6G5Vsp01I",
      "https://www.youtube.com/embed/eXK5mk8VNuQ",
      "https://www.youtube.com/embed/hlU8KRGeuTM",
      "https://www.youtube.com/embed/JhcJ6ULpc1U",
      "https://www.youtube.com/embed/GhQzSNW45j0",
      "https://www.youtube.com/embed/OpcznwRgUaY",
      "https://www.youtube.com/embed/8d9Fo8Hj50M",
      "https://www.youtube.com/embed/WJamVw7_RY8"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_63.png"},
        {image:"/cvla_64.png"},
        {image:"/cvla_65.png"},
        {image:"/cvla_66.png"},
        {image:"/cvla_67.png"},
        {image:"/cvla_68.png"},

    ]}
    exampleVideos={[]}
  />
);

export default VectorSpace;
